export default __webpack_public_path__ + "static/media/Toil of Woes.eb4e4a84.jpg";